import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { NavLink, Redirect } from "react-router-dom";
import { STATIC_URLS } from "consts";
import { downloadClientMSIStart } from "store/actions";
import { ReactComponent as MSIDownloadIcon } from "assets/images/app_svg/msi_download.svg";
import { ReactComponent as DownloadIcon } from "assets/images/app_svg/download.svg";

//using direct download instead of this page
function ClientSetup(props) {
  const [redirect, setRedirect] = useState(false);
  const [close, setClose] = useState(false);
  useEffect(() => {
    if (localStorage.getItem("dToken")) props.downloadClientMSIStart();
    else setRedirect(true);
  }, []);

  let content = "";

  if (!redirect)
    content = (
      <div className="msiDownload">
        <header className="header_cont">
          <div className="wrapper">
            <div className="backto_cont">
              <NavLink to={"/mirror/dashboard"} className="logo_cont" />
            </div>
          </div>
        </header>
        <main>
          <div className="wrapper">
            <div className="msiDownload_wrapper">
              <div className="msi_blk">
                <span className="msi_icon">
                  <MSIDownloadIcon />
                </span>
                <h1>
                  Welcome to IDrive<sup>®</sup> Mirror
                </h1>
                <p>
                  Use the shared link to download and install mass deployment
                  package on any computer. For complete guide on mass deployment{" "}
                  <a
                    href={
                      STATIC_URLS.massDeploy[
                        props?.origin === "idrive" ? "idrive" : "mirror"
                      ]
                    }
                    style={{
                      color: "#1374AB",
                      textDecoration: "none",
                      outline: "none"
                    }}
                    target="_blanck"
                  >
                    click here
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </main>
        <footer className="footer_cont">
          <div className="wrapper">
            <div className="copy_cont">
              <p>© IDrive Inc.</p>
            </div>
          </div>
        </footer>
        {!close && (
          <div className="download-blk" id="download-blk">
            <a
              href="javascript:;"
              className="close-download"
              onClick={() => setClose(true)}
            />
            <i className="icon-arrow">
              <DownloadIcon />
            </i>
            <p>Click IdriveMirror.msi</p>
          </div>
        )}
      </div>
    );
  else content = <Redirect to={"/mirror/dashboard"} />;

  return content;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ downloadClientMSIStart }, dispatch);
}

function mapStateToProps(state) {
  return {
    origin: state.account.origin
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientSetup);
